<!-- 组件说明 -->
<template>
  <div class="">
    <van-dropdown-menu active-color="#0D9869">
      <!-- 客户状态下拉 -->
      <van-dropdown-item
        title-class="dropdown-title"
        :title="'客户状态：' + customerStatusLabel"
        ref="customerStatus"
      >
        <customer-status
          :customerStatus="pageData.status"
          :statusList="statusList"
          @changeCustomerStatus="changeCustomerStatus"
        />
      </van-dropdown-item>
      <!-- 置业顾问下拉 -->
      <van-dropdown-item
        title-class="dropdown-title"
        :title="'置业顾问：' + adviserListLabel"
        ref="adviserList"
        @open="openAdviser"
      >
        <adviser-list
          ref="adviserItem"
          :adviserList="adviserList"
          :adviserCode="pageData.adviserCode"
          @changeAdvisers="changeAdvisers"
          @cancelAdviser="cancelAdviser"
        />
      </van-dropdown-item>
    </van-dropdown-menu>
    <van-list
      v-model="loading"
      :finished="finished"
      finished-text="没有更多了"
      @load="onLoad"
      :immediate-check="false"
    >
      <follow-item
        v-for="(item, index) in followList"
        :key="item.id"
        :followItem="item.recommend"
        :index="index"
        :noDisposeTime="item.noDisposeTime"
      />
    </van-list>
  </div>
</template>

<script>
import FollowItem from "./FollowComponent/FollowItem";
import CustomerStatus from "./FollowComponent/CustomerStatus";
import AdviserList from "./FollowComponent/AdviserList";
import {
  DropdownMenu as VanDropdownMenu,
  DropdownItem as VanDropdownItem,
  List as VanList,
} from "vant";
export default {
  components: {
    VanDropdownMenu,
    VanDropdownItem,
    FollowItem,
    VanList,
    CustomerStatus,
    AdviserList,
  },
  props: {
    projectCode: {
      type: String,
    },
    orgCode: {
      type: String,
    },
  },
  data() {
    return {
      loading: false,
      finished: false,
      followList: [],
      pageData: {
        orgCode: this.orgCode,
        projectCode: this.projectCode,
        status: -2,
        adviserCode: [""],
        current: 1,
        size: 10,
        requestEntry: 1,
      },
      //   客户状态列表
      statusList: [
        { label: "全部", value: -2 },
        { label: "未处理", value: -1 },
        { label: "未到访", value: 0 },
        { label: "已到访", value: 1 },
        { label: "已签约", value: 2 },
        { label: "已认购", value: 3 },
        { label: "已失效", value: 4 },
      ],
      value2: "a",
      adviserList: [
        {
          id: "",
          managerName: "全部",
          managerCode: "",
        },
      ],
    };
  },
  computed: {
    //   客户状态展示
    customerStatusLabel() {
      return this.statusList.find((res) => {
        return res.value === this.pageData.status;
      }).label;
    },
    // 置业顾问展示
    adviserListLabel() {
      if (this.pageData.adviserCode.length === 1) {
        return this.adviserList.find((res) => {
          return res.managerCode === this.pageData.adviserCode[0];
        }).managerName;
      } else {
        return "多选";
      }
    },
  },
  methods: {
    // 老版本状态映射新版本
    getNewStatus(old) {
      let map = {
        "-2": "2,3,4,5,6,7",
        "-1": 2,
        "0": 3,
        "1": 4,
        "2": 6,
        "3": 5,
        "4": 7,
      };
      return map[`${old}`] || "";
    },
    getList() {
      // 转换置业顾问的格式
      let pageData = Object.assign({}, this.pageData, {
        adviserCodes: this.pageData.adviserCode.join(","),
      });
      // 状态转换
      pageData.statuses = this.getNewStatus(pageData.status);
      let _pageData = JSON.parse(JSON.stringify(pageData));
      delete _pageData.adviserCode;
      this.$api.pmFollowList(_pageData).then((res) => {
        if (res.status && res.code === "0000") {
          this.followList.push(...res.body.records);
          if (this.pageData.current >= res.body.pages) {
            this.finished = true;
          }
        }
        this.loading = false;
      });
    },
    onLoad() {
      if (!this.finished) {
        this.pageData.current += 1;
        this.getList();
      }
    },
    // 改变客户状态
    changeCustomerStatus(status) {
      this.pageData.status = status.value;
      this.$refs.customerStatus.toggle();
    },
    // 改变置业顾问选择
    changeAdvisers(advisers) {
      this.pageData.adviserCode = advisers;
      this.$refs.adviserList.toggle();
    },
    // 关闭置业顾问选择
    cancelAdviser() {
      this.$refs.adviserList.toggle();
    },
    // 获取置业顾问列表
    getAdviser() {
      this.adviserList = [
        {
          id: "",
          managerName: "全部",
          managerCode: "",
        },
      ];
      this.$api
        .advi({ projectCode: this.projectCode, orgCode: this.orgCode })
        .then((res) => {
          if (res.status && res.code === "0000") {
            this.adviserList.push(...res.body);
          }
        });
    },
    openAdviser() {
      if (this.$refs.adviserItem) {
        this.$refs.adviserItem.initData();
      }
    },
    clearData() {
      this.pageData.current = 1;
      this.finished = false;
      this.followList = [];
    },
  },
  created() {
    this.getAdviser();
    this.getList();
  },
  watch: {
    // 项目变更刷新
    projectCode() {
      this.pageData.orgCode = this.orgCode;
      this.pageData.projectCode = this.projectCode;
      this.clearData();
      this.getList();
      this.getAdviser();
    },
    // 客户状态变化刷新
    "pageData.status"() {
      this.clearData();
      this.getList();
    },
    // 置业顾问变化刷新
    "pageData.adviserCode"() {
      this.clearData();
      this.getList();
    },
  },
};
</script>

<style lang="scss" scoped>
::v-deep .van-dropdown-menu__bar {
  box-shadow: none;
  .dropdown-title {
    font-size: 28px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #575757;
  }
}
::v-deep .van-dropdown-item__content {
  border-radius: 0px 0px 12px 12px;
}
</style>
